import { Button, Modal } from "react-bootstrap";

const BessAvailabilityExplainModal = ({
  show,
  onHide,
}: {
  show: boolean;
  onHide: () => void;
}) => (
  <Modal show={show} onHide={onHide} centered size="lg">
    <Modal.Header closeButton>
      <Modal.Title>BESS Availability</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p>
        BESS availability measures the proportion of time the battery was able to
        respond to dispatch. Unlike PV availability, it is assessed on a{" "}
        <strong>24-hour basis</strong> &mdash; the battery is expected to respond
        to a charge or discharge command around the clock, not only during
        daylight.
      </p>
      <p>
        <strong>availability = (T &minus; O) / (T &minus; C)</strong>
      </p>
      <p>
        where <strong>T</strong> is every settlement period in the window (the
        24-hour &ldquo;clock&rdquo;), <strong>O</strong> the periods lost to
        outages, and <strong>C</strong> the periods lost to <em>excused</em>{" "}
        (Excludable Event) outages. As with PV availability, excused periods are
        removed from <em>both</em> the numerator and the denominator, so an
        excused outage neither raises nor lowers availability.
      </p>
      <p>
        <strong>Outage periods (O)</strong> are the duration of health events
        classified as an <em>unplanned battery outage</em>; an{" "}
        <em>unplanned battery outage (excused)</em> &mdash; a grid/force-majeure or
        other Excludable Event an admin has marked as excused &mdash; is the
        excused periods <strong>(C)</strong>. Other impact types (unplanned PV
        outage, planned, transient, ignore) do not affect BESS availability.
      </p>
      <p>
        Graded against the site&apos;s <strong>contracted BESS availability</strong>{" "}
        (default 97%): green when measured &ge; contracted, amber within 1 pp
        below, red more than 1 pp below. Only battery sites show this metric.
      </p>
      <p className="text-muted small mb-0">
        The 24-hour denominator is a v1 simplification: periods where the battery
        was physically unable to respond because it had reached its minimum or
        maximum state of charge are not yet subtracted from the clock.
        &ldquo;Last month&rdquo; covers the previous complete calendar month;
        &ldquo;Last 12 months&rdquo; the trailing 12 complete calendar months.
      </p>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onHide}>
        Close
      </Button>
    </Modal.Footer>
  </Modal>
);

export default BessAvailabilityExplainModal;
